(() => {
  if (window.__relinCartLimitReady) return;

  const maxPerVariant = 5;
  const message = 'Puoi acquistare un massimo di 5 unità per variante.';
  let pendingCartRequest;

  const getLimit = (input) => {
    const value = Number(input?.dataset.relinMax || maxPerVariant);
    return Number.isFinite(value) && value > 0 ? Math.min(value, maxPerVariant) : maxPerVariant;
  };

  const getLineError = (input) => input?.closest('.quantity-popover')?.querySelector('.cart-item__error-text');

  const syncQuantityControl = (input) => {
    if (!input) return;

    input.readOnly = true;
    input.setAttribute('aria-readonly', 'true');
    input.setAttribute('aria-live', 'polite');
    input.dataset.relinQuantityDisplay = 'true';

    if (!input.dataset.relinBaseAriaLabel) {
      input.dataset.relinBaseAriaLabel = input.getAttribute('aria-label') || 'Quantità';
    }

    const limit = getLimit(input);
    const value = Number(input.value);
    const atLimit = Number.isFinite(value) && value >= limit;
    const plus = input.closest('quantity-input')?.querySelector('.quantity__button[name="plus"]');
    if (!plus) return;

    const nativeDisabled = plus.dataset.relinNativeDisabled === 'true';
    if (!plus.dataset.relinNativeDisabled) {
      plus.dataset.relinNativeDisabled = plus.disabled ? 'true' : 'false';
    }

    const disabled = nativeDisabled || atLimit;
    plus.disabled = disabled;
    plus.classList.toggle('disabled', disabled);
    if (atLimit && !nativeDisabled) {
      plus.setAttribute('aria-disabled', 'true');
    } else if (nativeDisabled) {
      plus.setAttribute('aria-disabled', 'true');
    } else {
      plus.removeAttribute('aria-disabled');
    }

    input.setAttribute('aria-label', `${input.dataset.relinBaseAriaLabel}, quantità ${Number.isFinite(value) ? value : 0} di ${limit}`);
  };

  const syncQuantityControls = () => {
    document.querySelectorAll('input.quantity__input[data-relin-max]').forEach(syncQuantityControl);
  };

  const clearMessage = (input) => {
    if (!input) return;
    input.setCustomValidity('');
    const error = getLineError(input);
    if (error?.textContent === message) error.textContent = '';
  };

  const showMessage = (input) => {
    if (!input) return;
    input.setCustomValidity(message);
    const error = getLineError(input);
    if (error) error.textContent = message;
    input.reportValidity();
  };

  const cartQuantityForVariant = (cart, variantId) =>
    (cart?.items || []).reduce(
      (total, item) => (String(item.variant_id) === String(variantId) ? total + Number(item.quantity || 0) : total),
      0
    );

  const readCart = () => {
    if (!pendingCartRequest) {
      pendingCartRequest = fetch(`${routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart unavailable');
          return response.json();
        })
        .finally(() => {
          pendingCartRequest = null;
        });
    }
    return pendingCartRequest;
  };

  window.relinCartLimit = {
    maxPerVariant,
    message,
    checkAdd: async (variantId, requestedQuantity = 1) => {
      if (!variantId) return { allowed: true };
      try {
        const cart = await readCart();
        const existingQuantity = cartQuantityForVariant(cart, variantId);
        const allowed = existingQuantity + Number(requestedQuantity || 1) <= maxPerVariant;
        return { allowed, message: allowed ? '' : message, existingQuantity };
      } catch {
        return { allowed: false, message };
      }
    },
  };
  window.__relinCartLimitReady = true;

  syncQuantityControls();
  new MutationObserver(syncQuantityControls).observe(document.body, { childList: true, subtree: true });

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest?.('input.quantity__input[data-relin-max]');
      if (!input) return;

      const value = Number(input.value);
      const limit = getLimit(input);
      if (Number.isFinite(value) && value > limit) {
        input.value = String(limit);
        showMessage(input);
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      clearMessage(input);
      queueMicrotask(() => syncQuantityControl(input));
    },
    true
  );

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.quantity__button');
    if (!button) return;

    const input = button.closest('quantity-input')?.querySelector('input.quantity__input[data-relin-max]');
    if (!input) return;

    clearMessage(input);
    queueMicrotask(() => syncQuantityControl(input));
  });
})();
